import TableCell from '../../../../table/TableCell'

function UserNameCell ()
{
    this.constructor = UserNameCell;
}

UserNameCell.prototype = _.create(TableCell.prototype, {

    init: function(userListUserInfo, groupName, timeZoneGroupName, rowObj, warnings, infos)
    {
        TableCell.call(this, userListUserInfo, rowObj);
        this.groupName = groupName;
        this.timeZoneGroupName = timeZoneGroupName;
        this.warnings = warnings;
        this.infos = infos;
        return this;
    },

    getTimeZoneGroupName: function()
    {
        return this.timeZoneGroupName;
    },

    getGroupName: function()
    {
        return this.groupName;
    },

    updateTimeZoneGroupName: function(timeZoneGroupName)
    {
        this.timeZoneGroupName = timeZoneGroupName;
        this.renderer.updateTimeZoneGroupName(this);
    },

    updateGroupName: function(groupName)
    {
        this.groupName = groupName;
        this.renderer.updateGroupName(this);
    }
});

export default UserNameCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/UserNameCell.js